import { render } from "./indexsixclient.vue?vue&type=template&id=a8100d50"
import script from "./indexsixclient.vue?vue&type=script&lang=js"
export * from "./indexsixclient.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__